// removed by extract-text-webpack-plugin
module.exports = {"fountainG":"fountainG__1x6W_","bounce_fountainG":"bounce_fountainG__3ikd-","fountainG_1":"fountainG_1__3B5Ud","fountainG_2":"fountainG_2__W_XJT","fountainG_3":"fountainG_3__2GLS3","fountainG_4":"fountainG_4__31FCc","fountainG_5":"fountainG_5__2yxsO","fountainG_6":"fountainG_6__2MWqN","fountainG_7":"fountainG_7__aO-9L","fountainG_8":"fountainG_8__3WwD5"};


//////////////////
// WEBPACK FOOTER
// ./components/Spinners/style.scss
// module id = I52i
// module chunks = 0